import React, { Component } from 'react';
import { findDOMNode } from 'react-dom'
import { Field, change } from 'redux-form';
import { FormTemplateField } from '../../../others'
import { Input, Textarea, Checkbox, DatePicker, ConditionalDropdown } from '../../../form/'
import { rangeBuilder } from '../../../HelperFunctions'
import { signedNumber, twoDecimalPlaces } from '../../../form/FormValidations';
import { connect } from 'react-redux';

class GlassForm extends Component {
  copyTo(source, destination) {
    const { name, pprops, showPrescriptionModal, prescription } = this.props
    const formName = (showPrescriptionModal || prescription?.id) ? 'PrescriptionForm' : 'examFinalizePrescriptionForm'
    const sphereNode = findDOMNode(this.refs[`${name}[${source}_sphere]`]).lastChild.value
    const cylinderNode = findDOMNode(this.refs[`${name}[${source}_cylinder]`]).lastChild.value
    const axisNode = findDOMNode(this.refs[`${name}[${source}_axis]`]).lastChild.value
    const addNode = findDOMNode(this.refs[`${name}[${source}_add]`]).lastChild.value
    const prismNode = findDOMNode(this.refs[`${name}[${source}_prism]`]).lastChild.value
    pprops.dispatch(change(formName, `${name}[${destination}_sphere]`, sphereNode))
    pprops.dispatch(change(formName, `${name}[${destination}_cylinder]`, cylinderNode))
    pprops.dispatch(change(formName, `${name}[${destination}_axis]`, axisNode))
    pprops.dispatch(change(formName, `${name}[${destination}_add]`, addNode))
    pprops.dispatch(change(formName, `${name}[${destination}_prism]`, prismNode))
  }
    getCylinderData() {
      const { cylinderFormat, examViewModern } = this.props
      if (cylinderFormat === 'negative') {
        return !examViewModern ? [...rangeBuilder(0, -10.25, -0.25, '+', ' ', 2, 'DS')] : [...rangeBuilder(0, -4.00, -0.25, '+', 'DS', 2)]
      }
      else if (cylinderFormat === 'positive') {
        return !examViewModern ? [...rangeBuilder(6.0, 0, -0.25, '+', ' ', 2, 'DS')] : [...rangeBuilder(3.75, 0, -0.25, '+', 'DS', 2)]
      }
      // both
      return !examViewModern ? [...rangeBuilder(6.0, -10.25, -0.25, '+', ' ', 2, 'DS')] : [...rangeBuilder(3.75, -4.00, -0.25, '+', 'DS', 2)]
    }

  render() {
    const { name, baseName, fieldValues, isTemplate, examViewModern, pprops: { recommendations } } = this.props

    const sphereVals = !examViewModern ? [{ key: 'Bal' }, ...rangeBuilder(20, -25.25, -0.25, '+', 'pl')] : [...rangeBuilder(18, -18.25, -0.25, '+', 'pl')]
    const cylinderVals = this.getCylinderData()
    const axisVals = !examViewModern ? [{ key: ' ' }, ...rangeBuilder(1, 181, 1, '', '', 0)] : [{ key: ' ' }, ...rangeBuilder(1, 181, 1, '', '', 0)]
    const addVals = !examViewModern ? [{ key: ' ' }, ...rangeBuilder(0.25, 6.25, 0.25, "+", "0.00")] : [{ key: ' ' }, ...rangeBuilder(0.25, 4.00, 0.25, '+', '0.00')]

    return (
      <span>
        <div className="row">
          <div className="col-xl-7 col-md-12">
            <div className="row">
              <Field
                ref={`${name}[od_sphere]`}
                name={`${name}[od_sphere]`}
                nextFocusRef={this.refs[`${name}[od_cylinder]`]}
                label={this.renderOdLabel()}
                component={ConditionalDropdown} supportAutoComplete={true}
                data={sphereVals}
                placeholder='Sphere'
                additionalValues={[' ', '0.00', 'Bal']}
                textField="key"
                valueField="key"
                validate={!examViewModern ? [] : [signedNumber, twoDecimalPlaces]}
                wrapperClasses="col label-icons" />
              <Field
                ref={`${name}[od_cylinder]`}
                name={`${name}[od_cylinder]`}
                nextFocusRef={this.refs[`${name}[od_axis]`]}
                placeholder='Cylinder'
                component={ConditionalDropdown} supportAutoComplete={true}
                additionalValues={[' ']}
                data={cylinderVals}
                textField="key" valueField="key" wrapperClasses="col pt-6"
                validate={!examViewModern ? [] : [signedNumber, twoDecimalPlaces]}
              />
              <Field ref={`${name}[od_axis]`} 
              placeholder='Axis'
              nextFocusRef={this.refs[`${name}[od_add]`]} name={`${name}[od_axis]`} component={ConditionalDropdown} supportAutoComplete={true}
                data={axisVals}
                textField="key" valueField="key" wrapperClasses="col pt-6" leftPosition={'-18.8rem'} />
              <Field ref={`${name}[od_add]`} placeholder='Add' nextFocusRef={this.refs[`${name}[os_sphere]`]} name={`${name}[od_add]`} component={ConditionalDropdown} supportAutoComplete={true}
                validate={!examViewModern ? [] : [signedNumber, twoDecimalPlaces]}
                data={addVals}
                textField="key" valueField="key" wrapperClasses=" col pt-6" />
              <Field ref={`${name}[od_prism]`} name={`${name}[od_prism]`} component={Input} placeholder="Prism" className="form-control mt-6" wrapperClasses="col form-group" />
              <FormTemplateField
                isTemplate={isTemplate}
                name={`${name}[issue_date]`}
                baseName={`${baseName}[fields][issue_date]`}
                fieldValues={fieldValues['fields']['issue_date']}
                component={DatePicker}
                placeholder="dd-mm-yy"
                wrapperClasses="col-3 form-group"
              />
            </div>
            <div className="row">
              <Field
                ref={`${name}[os_sphere]`}
                name={`${name}[os_sphere]`}
                nextFocusRef={this.refs[`${name}[os_cylinder]`]}
                label={this.renderOsLabel()}
                component={ConditionalDropdown} supportAutoComplete={true}
                additionalValues={[' ', '0.00', 'Bal']}
                data={sphereVals}
                placeholder='Sphere'
                textField="key"
                valueField="key"
                validate={!examViewModern ? [] : [signedNumber, twoDecimalPlaces]}
                wrapperClasses="col label-icons" />
              <Field
                ref={`${name}[os_cylinder]`}
                name={`${name}[os_cylinder]`}
                placeholder='Cylinder'
                nextFocusRef={this.refs[`${name}[os_axis]`]}
                component={ConditionalDropdown} supportAutoComplete={true}
                additionalValues={[' ']}
                data={cylinderVals}
                validate={!examViewModern ? [] : [signedNumber, twoDecimalPlaces]}
                textField="key" valueField="key" wrapperClasses="col pt-6"
              />
              <Field ref={`${name}[os_axis]`} placeholder='Axis' nextFocusRef={this.refs[`${name}[os_add]`]} name={`${name}[os_axis]`} component={ConditionalDropdown} supportAutoComplete={true}
                data={axisVals}
                textField="key" valueField="key" wrapperClasses="col pt-6" leftPosition={'-18.8rem'} />
              <Field ref={`${name}[os_add]`} placeholder='Add' name={`${name}[os_add]`} component={ConditionalDropdown} supportAutoComplete={true} data={addVals} validate={!examViewModern ? [] : [signedNumber, twoDecimalPlaces]}
                textField="key" valueField="key" wrapperClasses="col pt-6" />
              <Field ref={`${name}[os_prism]`} name={`${name}[os_prism]`} component={Input} placeholder="Prism" className="form-control mt-6" wrapperClasses="col form-group" />
              <FormTemplateField
                isTemplate={isTemplate}
                name={`${name}[expiry_date]`}
                baseName={`${baseName}[fields][expiry_date]`}
                fieldValues={fieldValues['fields']['expiry_date']}
                component={DatePicker}
                placeholder="dd-mm-yy"
                wrapperClasses="col-3 form-group label-icons"
              />
            </div>
          </div>
          <div className="col-xl-5 col-md-12">
            <div className="row">
              <FormTemplateField
                isTemplate={isTemplate}
                name={`${name}[notes]`}
                baseName={`${baseName}[fields][notes]`}
                fieldValues={fieldValues['fields']['notes']}
                component={Textarea}
                rows={4}
                className="form-control"
                wrapperClasses="col-5 form-group"
              />
              <div className="col-7">
                <span>Recommendations</span>
                <div className="row recommendation-layout mt-2">
                  {recommendations.map((recommendation) =>
                    <Field name={`${name}[recommendations]['${recommendation.name}']`} component={Checkbox} label={recommendation.name} wrapperClasses="col-6" />
                  )}
                </div>
                <small>Scroll to add more</small>
              </div>
            </div>
          </div>
        </div>
      </span>
    )
  }


  renderOdLabel() {
    return (
      <span>OD<small className="float-right btn-link" onClick={() => !this.props.isTemplate && this.copyTo('od', 'os')}><i className="la la-copy" />OS</small></span>
    )
  }

  renderOsLabel() {
    return (
      <span>OS<small className="float-right btn-link" onClick={() => !this.props.isTemplate && this.copyTo('os', 'od')}><i className="la la-copy" />OD</small></span>
    )
  }
}

const mapStateToProps = (state) => {
  const { setting: { orgConfig }, reports: { editing, report } } = state
  return {
    examViewModern: orgConfig.org_config?.exam_settings?.view_mode == 'modern',
    cylinderFormat: orgConfig.org_config?.exam_settings?.cylinder_format,
    showPrescriptionModal: editing?.showPrescriptionModal,
    prescription: report,
  }
}

export default connect(mapStateToProps)(GlassForm);